import { render, staticRenderFns } from "./MobKChart.vue?vue&type=template&id=123c7c28&scoped=true"
import script from "./MobKChart.vue?vue&type=script&setup=true&lang=js"
export * from "./MobKChart.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MobKChart.vue?vue&type=style&index=0&id=123c7c28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123c7c28",
  null
  
)

export default component.exports